import { ShopType, CheckoutType, MultiProviderConfig } from 'types';
import { asyncEligible } from 'config/sharedFunctions';
import { ProviderConfigList } from 'config/providers';
import { DefaultTheme } from 'config/themes';

export const PitchItIFramed: MultiProviderConfig = {
  name: 'PitchItIFramed',
  displayName: 'Pitchit',
  micrositeCode: 'PitchItIFrame',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: '',
  enableMicrositeLanding: true,
  title: 'Compare and shop for internet & TV with Pitchit',
  fallbackPhoneNumber: '999-999-9999', // TODO: Update with actual phone number
  fallbackLeadModePhoneNumber: '999-999-9999', // TODO: Update with actual lead mode phone number
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: DefaultTheme,
  needsDcSession: false,
  updaterCrossSellActive: false,
  source: 'PitchItIFrame',
  noOffersRetry: 2,
  providers: ProviderConfigList.filter(
    (provider) =>
      provider.providerCode !== 'earthlink' && provider.providerCode !== 'tds'
  ),
  movingAppBuyflowUrls: {
    development: 'http://bridgevine.io:3000/guest/tvi/buy',
    staging: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    qa: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    production: 'https://partner-cart.updater.com/guest/tvi/buy',
  },
  getCheckoutType: asyncEligible,
  iFrameConfig: {
    hideHeaderAndFooter: true,
    trustedHosts: {
      production: ['pitchit.ai'], // TODO: Update with actual production URL
    },
  },
};
